// implement your own methods in here, if your data is coming from A rest API

import * as User from './user';
import * as Activity from './activity';
import * as Profile from './adminprofile';
import * as DaftarTutor from './daftartutor';
import * as Laporan from './laporan';
import * as Files from './file';
import * as Mail from './mail';
import * as Post from './post';
import * as Chart from './chart';
import * as Project from './project';
import * as Forms from './form';

// Agroforestcape
import * as Perusahaan from './perusahaan';
import * as Kontrak from './kontrak';

// API
import * as Admin from './admin';

export default {
  // user
  getUser: User.getUser,
  getUserById: User.getUserById,

  // perusahaan
  getPerusahaan: Perusahaan.getPerusahaan,
  getPerusahaanById: Perusahaan.getPerusahaanById,

  // kontrak
  getKontrak: Kontrak.getKontrak,
  getKontrakById: Kontrak.getKontrakById,

  // form
  getForm: Forms.getForm,
  getFormById: Forms.getFormById,
  
  // project
  getProject: Project.getProject,
  
  // activity
  getActivity: Activity.default.getActivity,
  
  // post
  getPost: Post.getPost,
  
  // profile
  getProfileMenu: Profile.Menu,
  getProfileGroup: Profile.Groups,
  getProfileGroupById: Profile.getProfileById,
  
  // tutor
  getDaftarTutorMenu: DaftarTutor.Menu,
  getDaftarTutorGroup: DaftarTutor.Groups,
  getDaftarTutorGroupById: DaftarTutor.getChatById,
  
  // laporan
  getLaporanMenu: Laporan.Menu,
  getLaporanGroup: Laporan.Groups,
  getLaporanGroupById: Laporan.getLaporanById,
  
  // FIle 
  getFile: Files.getFile,
  getFileMenu: Files.getFileMenu,
  
  // mail
  getMail: Mail.getMail,
  getMailMenu: Mail.MailMenu,
  getMailById: Mail.getMailById,
  getMailByType: Mail.getMailByType,
  
  // chart data
  getMonthVisit: Chart.monthVisitData,
  getCampaign: Chart.campaignData,
  getLocation: Chart.locationData,
  
  getMonthVisit2: Chart.monthVisitData2,
  getCampaign2: Chart.campaignData2,
  getLocation2: Chart.locationData2,
  
  // *** API ***

  // admin
  getAdmin: Admin.getAdmin,
  getAdminById: Admin.getAdminById,

};